import * as React from 'react'
import { Text, View } from 'react-native'
import styled from '@theme/styled-components'

import Button from '@components/button/Button'
import AlertButton from '@components/button/AlertButton'
import DocumentButton from '@components/button/DocumentButton'

const ButtonsSection = () => {
  return (
    <Section>
      <SectionTitle>Buttons</SectionTitle>
      <Row>
        <ButtonColumn>
          <ButtonColor>Default</ButtonColor>
          <ButtonContainer>
            <Button label="My Button" onClick={() => undefined} status="active" />
          </ButtonContainer>
          <ButtonContainer>
            <Button label="My Button" leftIcon="phone" onClick={() => undefined} status="active" />
          </ButtonContainer>
          <ButtonContainer>
            <Button label="My Button" onClick={() => undefined} rightIcon="phone" status="active" />
          </ButtonContainer>
          <ButtonContainer>
            <Button label="My Button" onClick={() => undefined} status="disabled" />
          </ButtonContainer>
          <ButtonContainer>
            <Button label="My Button" onClick={() => undefined} status="loading" />
          </ButtonContainer>
        </ButtonColumn>
        <ButtonColumn>
          <ButtonColor>Light</ButtonColor>
          <ButtonContainer>
            <Button color="light" label="My Button" onClick={() => undefined} status="active" />
          </ButtonContainer>
          <ButtonContainer>
            <Button color="light" label="My Button" leftIcon="phone" onClick={() => undefined} status="active" />
          </ButtonContainer>
          <ButtonContainer>
            <Button color="light" label="My Button" onClick={() => undefined} rightIcon="phone" status="active" />
          </ButtonContainer>
          <ButtonContainer>
            <Button color="light" label="My Button" onClick={() => undefined} status="disabled" />
          </ButtonContainer>
          <ButtonContainer>
            <Button color="light" label="My Button" onClick={() => undefined} status="loading" />
          </ButtonContainer>
        </ButtonColumn>
        <ButtonColumn>
          <ButtonColor>Cancel</ButtonColor>
          <ButtonContainer>
            <Button label="My Button" color="cancel" onClick={() => undefined} status="active" />
          </ButtonContainer>
          <ButtonContainer>
            <Button label="My Button" color="cancel" leftIcon="phone" onClick={() => undefined} status="active" />
          </ButtonContainer>
          <ButtonContainer>
            <Button label="My Button" color="cancel" onClick={() => undefined} rightIcon="phone" status="active" />
          </ButtonContainer>
          <ButtonContainer>
            <Button label="My Button" color="cancel" onClick={() => undefined} status="disabled" />
          </ButtonContainer>
          <ButtonContainer>
            <Button label="My Button" color="cancel" onClick={() => undefined} status="loading" />
          </ButtonContainer>
        </ButtonColumn>
        <ButtonColumn>
          <ButtonColor>Other</ButtonColor>
          <ButtonContainer>
            <AlertButton label="Alert Button" onClick={() => undefined} />
          </ButtonContainer>
          <ButtonContainer>
            <DocumentButton count={3} onClick={() => undefined} />
          </ButtonContainer>
        </ButtonColumn>
      </Row>
    </Section>
  )
}

export default ButtonsSection

const Section = styled(View)`
  padding: 24px 0;
  border-color: ${(props) => props.theme.colors.disable};
  border-bottom-width: 1px;
  border-style: solid;
`
const SectionTitle = styled(Text)`
  margin-bottom: 15px;
  padding: 0 24px;
  text-decoration: underline;
  ${(props) => props.theme.fonts.LargeTitle};
`
const Row = styled(View)<{ dark?: boolean }>`
  flex-flow: row wrap;
`
const ButtonColumn = styled(View)<{ isLeft?: boolean }>`
  flex: 1;
  min-width: 250px;
  margin: 0 48px;
`
const ButtonContainer = styled(View)<{ isLeft?: boolean }>`
  margin-bottom: 12px;
`
const ButtonColor = styled(Text)`
  text-align: center;
  margin: 24px 0;
  ${(props) => props.theme.fonts.Headline};
`
